import {QueryClient} from "@tanstack/react-query";

/**
 * Shared QueryClient instance for the application.
 * This is in a separate file to avoid circular dependencies when
 * components that use react-query are rendered in dialogs/portals.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            gcTime: 60_000
        }
    }
});
